module.exports = __webpack_public_path__ + "static/media/icon_calender_arrow_left.33e00ae8.svg";